import React, { Fragment } from 'react'
import { filter, includes, get, map, groupBy, sumBy } from 'lodash'
import Table from 'UI/Table'

const toNextEvenNumber = (int) => int % 2 === 0 ? int : int + 1
const packsNeeded = (asset) => {
  if (asset.licensable) {
    let cores = parseInt(get(asset, 'cpu_cores') || 0)
    if (cores <= 4) { cores = 2 }
    else { cores = toNextEvenNumber(cores) / 2 }

    return cores
  }

  return 0
}
const column = (Header, id, filterMethod) => ({
  Header, type: 'number', id,
  accessor: ({ assets }) => filter(assets, filterMethod).length,
  Cell: ({ value }) => value.toLocaleString(),
  Footer: ({ data }) => (
    <Fragment>
      <strong>Total: </strong>{sumBy(data, id).toLocaleString()}
    </Fragment>
  )
})

const SqlSplaTable = ({ data }) => (
  <Table {...{
    data: map(groupBy(data, 'edition'), (assets, edition) => ({ assets, edition })),
    filterable: true,
    columns: [
      { Header: 'Edition', accessor: 'edition' },
      { Header: 'Total Cores', type: 'number', id: 'total', accessor: ({ assets }) => sumBy(assets, (asset) => parseInt(get(asset, 'cpu_cores') || 0)) },
      { Header: 'Device CPU Core Amount', columns: [
        column('4 or less', '4Cores', (asset) => get(asset, 'cpu_cores') <= 4),
        column('6', '6Cores', (asset) => includes([5, 6], get(asset, 'cpu_cores'))),
        column('8', '8Cores', (asset) => includes([7, 8], get(asset, 'cpu_cores'))),
        column('10', '10Cores', (asset) => includes([9, 10], get(asset, 'cpu_cores'))),
        column('12', '12Cores', (asset) => includes([11, 12], get(asset, 'cpu_cores'))),
        column('14', '14Cores', (asset) => includes([13, 14], get(asset, 'cpu_cores'))),
        column('16 or more', '16Cores', (asset) => get(asset, 'cpu_cores') >= 15),
      ]},
      {
        Header: 'Needed Packs',
        type: 'number',
        id: 'neededPacks',
        accessor: ({ assets }) => sumBy(assets, asset => packsNeeded(asset)),
        Cell: ({ value }) => value.toLocaleString(),
        Footer: ({ data }) => (
          <Fragment>
            <strong>Total: </strong>{sumBy(data, 'neededPacks').toLocaleString()}
          </Fragment>
        )
      },
    ],
    SubComponent: (row) => (
      <Table {...{
        data: row.original.assets,
        filterable: true,
        showPagination: false,
        defaultPageSize: row.original.assets.length,
        columns: [
          { Header: 'Customer', accessor: 'customer_name' },
          { Header: 'Device', accessor: 'device_name' },
          { Header: 'Power', accessor: 'power_state', type: 'powerState' },
          { Header: 'Platform Type', accessor: 'platform_type' },
          { Header: 'Version', accessor: 'version' },
          { Header: 'Last Seen', accessor: 'last_seen' },
          {
            Header: 'CPU Cores',
            accessor: 'cpu_cores',
            Footer: ({ data }) => (
              <Fragment>
                <strong>Total: </strong>{sumBy(data, 'cpu_cores').toLocaleString()}
              </Fragment>
            )
          },
          {
            Header: 'Packs Needed',
            id: 'packsNeeded',
            accessor: (asset) => packsNeeded(asset),
            Footer: ({ data }) => (
              <Fragment>
                <strong>Total: </strong>{sumBy(data, 'packsNeeded').toLocaleString()}
              </Fragment>
            )
          },
        ]
      }} />
    )
  }} />
)

export default SqlSplaTable
